import ls from '../../utils/localStorage.js';
import { getReport,getReportQuery,getReportShow } from '../../api/api';

const state = {
    report_list: '',
    report_detail: ''
}

const mutations = {
     UPDATE_REPORT_LIST(state,payload) {
         state.report_list = JSON.parse(payload);
     },
     UPDATE_REPORT_DETAIL(state,payload) {
         state.report_detail = JSON.parse(payload);
     }
}

const getters = {

}

const actions = {
    // 发布信息
    requestReport(store,item) {
        getReport(item.data).then( data => {
            if(data.success.message == '已存在') {
               item.thit.$toast('你的资料已被 '+ data.data +' 报备了');
            }else{
               item.registerToast.clear();
               item.thit.$toast({
                   duration: 800,
                   message: '报备成功'
               });
               return window.location.href="/customer";
            }
        }).catch(error => {
           item.registerToast.clear();
        });
    },

    // 列表
    requestReportQuery(store,item) {
        getReportQuery().then( data => {
          store.commit('UPDATE_REPORT_LIST',JSON.stringify(data.data));
        }).catch(error => {

        })
    },

    // 详情
    requestReportDetail(store,item) {
        getReportShow(item.id).then( data => {
            store.commit('UPDATE_REPORT_DETAIL',JSON.stringify(data.data));
        }).catch(error => {

        })
    }
}

export default {
    state,
    mutations,
    getters,
    actions
}
